export default __webpack_public_path__ + "static/media/events.1a86cb8b.svg";